module.exports = {
      id: "icon-home-plus-usage",
      viewBox: "0 0 27.193 24.672",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#icon-home-plus",
      toString: function () {
        return this.url;
      }
    }